import { useMemo } from 'react';

import { Basket } from '../../../Modules/Basket';
import { useAppDispatch } from '../../../hooks/redux';
import { useBasket } from '../../../hooks/useBasket';
import { useUser } from '../../../hooks/useUser';

export const useQuantityButton = (item: any) => {
  const dispatch = useAppDispatch();
  const { items, cards_id } = useBasket();
  const { loggedIn } = useUser();
  //получить данные карточки
  let availabilityCount =
    Basket.getItemFromBasket(items, item.id)?.quantity || 0;
  const addCount = async (item: any) => {
    setTimeout(async () => {
      await Basket.addedOrRemoveCount('add', items, item, cards_id, dispatch);
      //Вызов синхронизации корзины  с сервером, если залогинен
    }, 500);
    /*    if (loggedIn) await Basket.basketSynchronization(dispatch); //Синхронизация при уменьшении кол-ва товара в корзине*/
  };

  const removeCount = async (item: any) => {
    setTimeout(async () => {
      await Basket.addedOrRemoveCount(
        'remove',
        items,
        item,
        cards_id,
        dispatch
      );
      //Вызов синхронизации корзины  с сервером, если залогинен
      /*      if (loggedIn) await Basket.basketSynchronization(dispatch); //Синхронизация при уменьшении кол-ва товара в корзине*/
    }, 500);
  };

  //Проверяет, есть ли нужно количество штук товара
  const checkCount = (item: any) => {
    let cartItems: [] = Basket.getFromLocalStorage();
    let idsItems = cartItems.filter((elem: any) => elem.id === item.id);
    return idsItems.some(
      (elem: any) => elem.quantity >= item.availability_count
    );
  };

  return useMemo(
    () => ({
      addCount,
      removeCount,
      checkCount,
      availabilityCount,
    }),
    [addCount, removeCount, checkCount, availabilityCount]
  );
};
